<template>
  <div class="flex flex-wrap mb-2 relative">
    <!-- 左側的主要內容區域 -->
    <div ref="adStrategy" class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6 relative">
      <div>
        <span class="text-red-500">*</span>
        <span class="text-grap-700 align-middle">廣告策略</span>
        <!-- <button
          v-if="!editPageType"
          id="keywordMix"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['KeywordMix']['video_teaching']}}
        </button> -->
      </div>
      <!-- 每個節點 -->
      <div class="col-span-8 text-center bg-gray-100 h-16 py-3 pl-10 pr-3 mr-2">
        <div class="flex justify-between items-center bg-gray-100">
          <div class="font-bold pl-3">測試素材</div>
          <InputSwitch :disabled="editPageType" v-model="haveTest" class="flex-none"/>
        </div>
        <div class="text-gray-400 text-left text-xs pl-3">開啟時，各階段會維持相同目標，並以成功素材持續投放</div>
      </div>
      <div class="scrollbar-y" :style="{height: `520px`}">
        <div
          v-for="(node, index) in treeData"
          :key="index"
          class="relative flex flex-col items-center"
        >
          <!-- 節點本體 -->
          <StageTreeNode
            :node="node"
            :groupIndex="0"
            :index="index"
            :isSingleNode="treeData.length === 1"
            :totalNodes="totalNodes"
            :isLastStage="index === treeData.length - 1"
            :isTestStage="haveTest && index === 0 && node.some(item => item.method === 'META_TEST')"
            v-bind:editPage="editPageType"
            @add-next-stage="addNextStage"
            @add-current-node-data="addCurrentNodeData"
            @delete-node="deleteNode"
            @update-is-go-ahead="updateIsGoAhead"
            @update-method-change="updateMethodChange"
          />

          <!-- 垂直箭頭 -->
          <div
            v-if="index < treeData.length - 1"
            class="relative flex items-center justify-center"
          >
            <div class="arrow-container w-1 flex flex-col items-center">
              <!-- 垂直線 -->
              <div class="h-4 w-px bg-black"></div>
              <!-- 箭頭 -->
              <div
                class="w-4 h-4 bg-black transform rotate-45 -translate-y-2"
                style="clip-path: polygon(100% 0%, 0% 100%, 100% 100%);"
              ></div>
            </div>
          </div>
        </div>

        <div v-if="false" class="flex items-center space-x-8 tree_outer">
          <div v-for="(stage, stageIndex) in stageTreeListData" :key="stageIndex" class="flex items-center">
            <!-- Data Box -->
            <div class="border border-black rounded-md py-2 px-4 w-52">
              <div v-for="(item, itemIndex) in stage" :key="itemIndex" class="last:mb-0">
                <span :class="{'text-blue-500': item.isGoAhead, 'text-gray-800': !item.isGoAhead}">
                  {{ methodList[item.method] }} ({{ platformList[item.platform] }})
                  <i v-if="item.isGoAhead === true" v-tooltip.top="'為前進條件'" class="pi pi-arrow-right text-sm"></i>
                </span>
              </div>
            </div>

            <!-- Arrow -->
            <div v-if="stageIndex < stageTreeListData.length - 1" class="ml-4">
              <div class="w-8 h-8 border-t-4 border-r-4 border-black transform rotate-45"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 右側的補充內容 -->
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar"></div>
  </div>
</template>

<script>
import InputSwitch from "primevue/inputswitch";
import StageTreeNode from "./StageTreeNode.vue";

export default {
  components: { 
    InputSwitch,
    StageTreeNode 
  },
  props: {
    editPage: {
      type: Boolean
    },
    defaultStage:{
      type: Object,
    },
    treeMenu:{
      type: Object,
    },
    stageTreeHaveTest: {
      type: Boolean
    },
    stageTreeList: {
      type: Array,
    },
    stageTreeContent: {
      type: Array,
    },
  },
  data() {
    return {
      // 初始化的資料結構
      haveTest: true,
      treeData: [],
      treeContent: [],
      methodList: {
        META_TEST: '測試素材',
        META_ASC: 'ASC',
        META_KW: '精準興趣',
        META_LA: '類似受眾',
        META_RT: '再行銷',
      },
      platformList: {
        facebook: 'Facebook',
        tiktok: 'Tiktok'
      },
      rawData: [
        [
          { method: 'META_ASC', platform: 'facebook', isGoAhead: true },
        ],
        [
          { method: 'META_LA', platform: 'facebook', isGoAhead: false },
          { method: 'META_KW', platform: 'facebook', isGoAhead: true }
        ],
        [
          { method: 'META_LA', platform: 'facebook', isGoAhead: false },
          { method: 'META_KW', platform: 'facebook', isGoAhead: false },
          { method: 'META_ASC', platform: 'facebook', isGoAhead: true },
          { method: 'META_RT', platform: 'facebook', isGoAhead: false }
        ],
        [
          { method: 'META_KW', platform: 'facebook', isGoAhead: true }
        ],
        [
          { method: 'META_LA', platform: 'facebook', isGoAhead: false },
          { method: 'META_ASC', platform: 'facebook', isGoAhead: false }
        ]
      ],
      dataTotalNodes: 0,
      prevTreeData: null,
    };
  },
  watch: {
    // 'haveTest': function(value){
    // //  console.log('StageTreeComponent haveTest', value);

    //   // console.log('b this.stageTreeHaveTestData', this.stageTreeHaveTestData);
    //   // this.stageTreeHaveTestData = value;
    //   // console.log('a this.stageTreeHaveTestData', this.stageTreeHaveTestData);
    //   this.$emit('childStageTreeHaveTest', value);
    // },
    haveTest: {
      immediate: true,
      handler(newValue) {
      //  console.log('StageTreeComponent.vue haveTest', newValue);
        if (newValue) {
          // 判斷第一個節點是否包含 META_TEST
          const firstNodeHasTest = this.treeData[0]?.some(item => item.method === "META_TEST");
          if (!firstNodeHasTest) {
            // 插入包含 META_TEST 的節點到最前面
            this.treeData.unshift([{ method: "META_TEST", platform: "facebook", isGoAhead: true, isHold: false, area: 2, list: this.treeMenu['META_TEST'] }]);

            if(this.defaultStage != null && this.defaultStage != '' && typeof this.defaultStage !== 'undefined'){
            //  console.log('StageTreeComponent.vue defaultStage');
              let pushTreeContent = this.defaultStage['USE_TEST']['META_TEST'];

              this.treeContent.unshift([
                pushTreeContent,
              ]);

            //  console.log('this.treeContent', this.treeContent);

              let treeContentLength = this.treeContent.length;
              let _tmpTreeContentLength = [];

              for(let i = 0; i < treeContentLength; i++){
                let treeContentItemLength = this.treeContent[i].length;
                let _tmpTreeContentItemLength = [];
              //  console.log('this.treeContent['+i+'].method', this.treeContent[i]);
                for(let j = 0; j < treeContentItemLength; j++){
                //  console.log('this.treeContent['+i+']['+j+']', this.treeContent[i][j]);
                  if(this.treeContent[i][j].method != null && this.treeContent[i][j].method != '' && typeof this.treeContent[i][j].method != 'undefined'){
                  //  console.log('this.treeContent['+i+']['+j+'].method', this.treeContent[i][j].method);
                    if(this.treeContent[i][j].method != 'META_TEST'){
                      this.treeContent[i][j].goalsData.showBlock = false;
                      this.treeContent[i][j].pdData.showBlock = false;
                      this.treeContent[i][j].postData.showBlock = false;

                      this.treeData[i][j].list['Forward'].showStatus = false;
                    }
                  }
                //  console.log('this.treeContent['+i+']['+j+']', this.treeContent[i][j]);

                  _tmpTreeContentItemLength.push(this.treeContent[i][j]);
                }

                _tmpTreeContentLength.push(_tmpTreeContentItemLength);
              }
            }

          //  console.log('this.treeContent', this.treeContent);
          }
        } else {
          // 如果 haveTest 為 false，移除最前面的節點
          const firstNodeHasTest = this.treeData[0]?.some(item => item.method === "META_TEST");
          if (firstNodeHasTest) {
            this.treeData.shift();
            this.treeContent.shift();

            let treeContentLength = this.treeContent.length;
            let _tmpTreeContentLength = [];
            for(let i = 0; i < treeContentLength; i++){
              let treeContentItemLength = this.treeContent[i].length;
              let _tmpTreeContentItemLength = [];

              for(let j = 0; j < treeContentItemLength; j++){
                if(this.treeContent[i][j].method != null && this.treeContent[i][j].method != '' && typeof this.treeContent[i][j].method != 'undefined'){
                //  console.log('this.treeContent['+i+']['+j+'].method', this.treeContent[i][j].method);
                  if(this.treeContent[i][j].method != 'META_TEST'){
                    this.treeContent[i][j].goalsData.showBlock = true;
                    this.treeContent[i][j].pdData.showBlock = true;
                    this.treeContent[i][j].postData.showBlock = true;

                    this.treeData[i][j].list['Forward'].showStatus = true;
                  }
                }
              //  console.log('this.treeContent['+i+']['+j+']', this.treeContent[i][j]);

                _tmpTreeContentItemLength.push(this.treeContent[i][j]);
              }

              _tmpTreeContentLength.push(_tmpTreeContentItemLength);
            }

          //  console.log('this.treeContent', this.treeContent);
          }
        }

        this.$emit('childStageTreeHaveTest', newValue);
      },
    },
    treeData: {
      handler(newVal) {
        if (JSON.stringify(newVal) === JSON.stringify(this.prevTreeData)) return; // 避免无意义的触发
        this.prevTreeData = JSON.parse(JSON.stringify(newVal)); // 记录新值

      //  console.log('treeData changed:', newVal);

        if (newVal.length > 0) {
          const lastGroup = newVal[newVal.length - 1];
          lastGroup.forEach(item => {
            item.isGoAhead = false;
          });
        }

      //  console.log('isGoAhead treeData:', newVal);
      //  console.log('treeData defaultStage 內容:', this.defaultStage);

        this.$emit('childStageTreeList', newVal);
      },
      deep: true,
    },
    defaultStage(newVal, oldVal) {
    //  console.log('StageTreeComponent defaultStage changed:', oldVal, '->', newVal);
    },
    stageTreeHaveTest(newVal, oldVal) {
    //  console.log('StageTreeComponent stageTreeHaveTest changed:', oldVal, '->', newVal);
      this.haveTest = newVal;
    },
    // 監聽另一個 prop 的變化
    stageTreeList(newVal, oldVal) {
    //  console.log('StageTreeComponent stageTreeList changed:', oldVal, '->', newVal);
      this.treeData = newVal;
    },
    // 監聽 stageTreeContent 的變化
    stageTreeContent(newVal, oldVal) {
    //  console.log('StageTreeComponent stageTreeContent changed:', oldVal, '->', newVal);
      this.treeContent = newVal;
    },
  },
  mounted() {
  //  console.log('mounted defaultStage 內容:', this.defaultStage);

  //  console.log('stageTreeHaveTest 內容:', this.stageTreeHaveTest);
  //  console.log('b treeData:', this.haveTest);
    this.haveTest = this.stageTreeHaveTest;
  //  console.log('a treeData:', this.haveTest);

  //  console.log('StageTreeList 內容:', this.stageTreeList);
  //  console.log('b treeData:', this.treeData);
    this.treeData = this.stageTreeList;
  //  console.log('a treeData:', this.treeData);

  //  console.log('stageTreeContent 內容:', this.stageTreeContent);
  //  console.log('b treeData:', this.treeContent);
    this.treeContent = this.stageTreeContent;
  //  console.log('a treeData:', this.treeContent);
  },
  methods: {
    // 新增下一階段節點
    addNextStage(groupIndex, index) {
    //  console.log('addNextStage');
      this.treeData.push([
        { method: "META_KW", platform: "facebook", isGoAhead: false, isHold: false, area: 2, list: this.treeMenu['META_KW']},
      ]);
    //  console.log(this.treeData);

    //  console.log('this.haveTest', this.haveTest);
    //  console.log(typeof(this.haveTest));

      let pushTreeContent = this.defaultStage['NOT_USE_TEST']['META_KW'];
      if(this.haveTest === true){
        pushTreeContent = this.defaultStage['USE_TEST']['META_KW'];
      }

      this.treeContent.push([
        pushTreeContent,
      ]);
    //  console.log(this.treeContent);
    },
    addCurrentNodeData(groupIndex, index) {
    //  console.log('addCurrentNodeData', groupIndex, index);
    //  console.log('this.treeData', this.treeData);
    //  console.log('this.treeContent', this.treeContent);
      const currentGroup = this.getGroupByIndex(this.treeData, groupIndex);
      const currentContentGroup = this.getGroupByIndex(this.treeContent, groupIndex);

      if (!currentGroup || !currentGroup[index]) {
        console.warn('指定的節點不存在');
        return;
      }

      let pushTreeContent = this.defaultStage['NOT_USE_TEST']['META_KW'];
      if(this.haveTest === true){
        pushTreeContent = this.defaultStage['USE_TEST']['META_KW'];
      }

    //  console.log('pushTreeContent', pushTreeContent);

      // 獲取指定節點並添加資料
      if (Array.isArray(currentGroup[index])) {
      //  console.log('#1');
      //  console.log('b currentGroup', currentGroup);
        currentGroup[index].push({
          method: "META_KW",
          platform: "facebook",
          isGoAhead: false,
          isHold: false,
          area: 2, 
          list: this.treeMenu['META_KW'],
        });
      //  console.log('a currentGroup', currentGroup);

      //  console.log('b currentContentGroup', currentContentGroup);
        currentContentGroup[index].push(pushTreeContent);
      //  console.log('a currentContentGroup', currentContentGroup);
      } else {
      //  console.log('#2');
        currentGroup[index] = [
          currentGroup[index],
          { method: "META_KW", platform: "facebook", isGoAhead: false, isHold: false, area: 2, list: this.treeMenu['META_KW'] },
        ];

        currentContentGroup[index] = [
          currentContentGroup[index],
          pushTreeContent,
        ];
      }
    //  console.log(currentGroup);
    //  console.log(currentContentGroup);
    },
    // 刪除節點
    deleteNode(groupIndex, index, subIndex = null) {
    //  console.log('deleteNode');
      const currentGroup = this.getGroupByIndex(this.treeData, groupIndex);
      const currentContentGroup = this.getGroupByIndex(this.treeContent, groupIndex);

      if (subIndex !== null) {
      //  console.log('#1');
        if (currentGroup[index].length > 1) {
          currentGroup[index].splice(subIndex, 1);
          currentContentGroup[index].splice(subIndex, 1);
        }
      } else {
      //  console.log('#2');
        // const totalNodes = this.treeData.flat().length;
        const totalNodes = this.treeData.length;
        if (totalNodes > 1) {
          currentGroup.splice(index, 1);
          currentContentGroup.splice(index, 1);
        } else {
          console.warn("無法刪除僅存的節點");
        }
      }
    //  console.log(currentGroup);
    //  console.log(currentContentGroup);
    },
    // 更新節點中的 isGoAhead 狀態
    updateIsGoAhead(groupIndex, index, subIndex) {
    //  console.log('updateIsGoAhead');
      const currentGroup = this.getGroupByIndex(this.treeData, groupIndex);

      if (Array.isArray(currentGroup[index])) {
        currentGroup[index].forEach((item, idx) => {
          item.isGoAhead = idx === subIndex;

          if((idx === subIndex) === false){
            item.isHold = false;
          }
        });
      }
    //  console.log(currentGroup);
    },
    updateMethodChange(node_index, campaign_index, item_method){
    //  console.log('updateMethodChange');
      let changeTreeContent = this.defaultStage['NOT_USE_TEST'][item_method];
      if(this.haveTest === true){
        changeTreeContent = this.defaultStage['USE_TEST'][item_method];
      }

    //  console.log('item_method', item_method);
    //  console.log('treeMenu', this.treeMenu);
    //  console.log('treeMenu[item_method]', this.treeMenu[item_method]);
    //  console.log('b this.treeData', this.treeData);
      this.treeData[node_index][campaign_index].list = this.treeMenu[item_method];
    //  console.log('b this.treeData', this.treeData);

    //  console.log('b this.stageTreeContentData', this.stageTreeContentData);
      this.stageTreeContentData[node_index][campaign_index] = changeTreeContent;
    //  console.log('a this.stageTreeContentData', this.stageTreeContentData);
    },
    // 遞迴獲取指定層級的節點群組
    getGroupByIndex(data, groupIndex) {
      let group = data;
      for (let i = 0; i < groupIndex; i++) {
        group = group.find((item) => Array.isArray(item));
      }
      return group;
    },
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    stageTreeHaveTestData: {
      get: function () {
        return this.stageTreeHaveTest
      },
      set: function (value) {
        this.$emit('update:stageTreeHaveTestData', value)
      },
    },
    totalNodes() {
      return this.treeData.flat().length;
    },
    stageTreeListData: {
      get: function () {
        return this.stageTreeList
      },
      set: function (value) {
        this.$emit('update:stageTreeList', value)
      },
    },
    stageTreeContentData: {
      get: function () {
        return this.stageTreeContent
      },
      set: function (value) {
        this.$emit('update:stageTreeContentData', value)
      },
    },
  }
};
</script>

<style>
  .tree_outer {
    max-width: 930px; /* 設定外部容器的最大寬度 */
    overflow-x: auto; /* 溢出時產生橫向滾動條 */
    padding: 5px;
  }
  /* 自定義滾動條樣式 */
  .tree_outer::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .tree_outer::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .tree_outer::-webkit-scrollbar-thumb {
    background: #D9D9D9;
    border-radius: 6px;
  }

  .tree_outer::-webkit-scrollbar-thumb:hover {
    background: #D9D9D9;
  }
</style>